import { LocationActions } from "./locationActions";

const clearLocation = {
  primary_info: {
    name: "",
    type: "",
    parent_id: null,
    main_parent_id: null,
    service_offered: "",
    need_opening_hour: "",
    deliver_throughout_description: "",
    your_local_florist_description: "",
    sequence_number: 0,
    slug: "",
    blurb: "",
    city_zipcodes: "",
    description: "",
    status: 1
  },
  cms_location_categories: [],
  banners: [],
  seo: {
    id: 0,
    parent_id: 0,
    module: "locations",
    is_robot: false,
    is_no_follow: false,
    is_no_index: false,
    image_alt_text: "",
    page_title: "",
    meta_title: "",
    meta_description: "",
    canonical_url: "",
    og_title: "",
    og_description: "",
    og_image_url: "",
    og_image_alt: "",
    og_url: "",
    og_image_type: "",
    og_site_name: "",
    og_image_height: 0,
    og_image_width: 0,
    twitter_title: "",
    twitter_image_url: "",
    twitter_description: "",
    twitter_site: "",
    twitter_creator: "",
    schema: "",
  },
  meta_content: [],
  faq: [],
};

const newBanner = {
  id: 0,
  parent_id: 0,
  module: "locations",
  position: "LEFT",
  banner_text: "",
  button_label: "",
  button_url: "",
  description: "",
  image: "",
  is_supported_image: 1,
};

function locationReducer(state, action) {
  switch (action.type) {

    case LocationActions.SET_BANNER_DATA:
      let setBannersData = state.banners ? [...state.banners] : [];
      setBannersData.push(action.payload);
      return {
        ...state,
        banners: setBannersData,
      };
    case LocationActions.ADD_NEW_BANNER:
      let aBanner = state.banners ? [...state.banners] : [];
      aBanner.push(newBanner);
      return {
        ...state,
        banners: aBanner,
      };
    case LocationActions.REMOVE_BANNER:
      let rBanner = [...state.banners];
      rBanner.splice(action.payload, 1);
      return {
        ...state,
        banners: rBanner,
      };
    case LocationActions.UPDATE_BANNER_DATA:
      let bannersData = [...state.banners];
      bannersData[action.payload.index] = {
        ...action.payload.values,
      };
      return {
        ...state,
        banners: bannersData,
      };
    case LocationActions.CHECK_BANNER_DATA:
      return {
        ...state,
        bannerError: action.payload,
      };
    case LocationActions.SET_LOCATION_PRIMARY_DATA:

      return {
        ...state,
        primary_info: action.payload,
      };
    case LocationActions.SET_RELATED_CATEGORY:

      let relatedCatData = state.cms_location_categories ? [...state.cms_location_categories] : [];
      relatedCatData = [...relatedCatData, {
        category_hierarchy_id: null,
        seo: [],
      }]
      return {
        ...state,
        cms_location_categories: relatedCatData,
      };
    case LocationActions.DELETE_RELATED_CATEGORY:
      let deleteCatData = [...state.cms_location_categories];
      deleteCatData.splice(action.payload, 1);
      return {
        ...state,
        cms_location_categories: deleteCatData,
      };
    case LocationActions.UPDATE_RELATED_CATEGORY:

      let updatedCatData = state.cms_location_categories ? [...state.cms_location_categories] : [];
      updatedCatData[action.index].category_hierarchy_id = action.payload;

      return {
        ...state,
        cms_location_categories: updatedCatData,
      };
    case LocationActions.SET_EXISTING_RELATED_CATEGORY:
      let existingRelatedCategory = state.cms_location_categories ? [...state.cms_location_categories] : [];
      existingRelatedCategory.push(action.payload);
      return {
        ...state,
        cms_location_categories: existingRelatedCategory,
      };
    case LocationActions.SET_SEO_DATA:
      let updatedCatSeoData = state.cms_location_categories ? [...state.cms_location_categories] : [];
      let seoData = { ...updatedCatSeoData[action.index].seo, ...action.payload };
      updatedCatSeoData[action.index].seo = seoData;
      return {
        ...state,
        cms_location_categories: updatedCatSeoData,
      };
    case LocationActions.CLEAR_DATA_LOCATION:
      return clearLocation;

    case LocationActions.UPDATE_SEO_DATA:
      let seoDataNew = { ...state.seo, ...action.payload };
      return {
        ...state,
        seo: seoDataNew,
      };
    case LocationActions.CHECK_SEO_DATA:
      return {
        ...state,
        seoError: action.payload,
      };
    case LocationActions.UPDATE_OG_INFO_DATA:
      let ogInfoData = { ...state.seo, ...action.payload };
      return {
        ...state,
        seo: ogInfoData,
      };
    case LocationActions.CHECK_OG_INFO_DATA:
      return {
        ...state,
        ogInfoError: action.payload,
      };
    case LocationActions.UPDATE_TWITTER_INFO_DATA:
      let twitterInfoData = { ...state.seo, ...action.payload };
      return {
        ...state,
        seo: twitterInfoData,
      };
    case LocationActions.CHECK_TWITTER_INFO_DATA:
      return {
        ...state,
        twitterInfoError: action.payload,
      };
    case LocationActions.UPDATE_SCHEMA_DATA:
      let schemaData = { ...state.seo, ...action.payload };
      return {
        ...state,
        seo: schemaData,
      };
    case LocationActions.CHECK_SCHEMA_DATA:
      return {
        ...state,
        schemaError: action.payload,
      };
    case LocationActions.UPDATE_META_CONTENT_DATA:
      let metaContentData =
        state.meta_content && state.meta_content.length > 0
          ? [...state.meta_content]
          : [];
      metaContentData[action.index] = action.payload;

      return {
        ...state,
        meta_content: metaContentData,
      };

    case LocationActions.REMOVE_FAQ:
      let removeFaqList = [...state.faq];
      const faqIndex = removeFaqList.findIndex(faq => faq.id === action.payload);
      if (faqIndex !== -1) {
        removeFaqList[faqIndex] = { ...removeFaqList[faqIndex], status: 2 };
      }
      return {
        ...state,
        faq: removeFaqList,
      };
    case LocationActions.UPDATE_FAQ_DATA:
      let faqData = state.faq && state.faq.length > 0 ? [...state.faq] : [];
      const updateFaqIndex = faqData.findIndex(faq => faq.id === action.index);
      if (updateFaqIndex !== -1) {
        faqData[updateFaqIndex] = { ...faqData[updateFaqIndex], ...action.payload };
      }
      return {
        ...state,
        faq: faqData,
      };

    case LocationActions.SET_META_CONTENT_DATA:
      return {
        ...state,
        meta_content: action.payload,
      };

    case LocationActions.SET_FAQ_DATA:
      return {
        ...state,
        faq: action.payload,
      };
    default:
      return state;
  }
}

export default locationReducer;